import styled from 'styled-components/macro';

export const StyledLiveNewsSidebar = styled.div<{ showMore: boolean }>`
  margin-bottom: 4.6rem;
  overflow: overlay;
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.6rem;
    padding: 0 1.6rem;
  }
  .title {
    font-size: 1.5rem;
    font-weight: 700;
    color: ${(props) => props.theme.fontColor.primary};
    display: flex;
    align-items: center;
  }
  .counter {
    font-size: 1.6rem;
    font-weight: 700;
    color: ${(props) => props.theme.grey.light};
    margin-left: 0.8rem;
  }
  .pager {
    display: flex;
    align-items: center;
    .btn-icon {
      background-image: none;
      background-color: transparent;
      border: 0;
      height: 3rem;
      width: 3rem;
      display: flex;
      align-items: center;
      justify-content: center;
      &.prev {
        transform: rotate(180deg);
      }
    }
  }
  .card {
    margin-bottom: 4.8rem;
  }
`;
